import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ContentSurface from '../ContentSurface';
import { GroupRowSkeleton } from '../Skeleton';
import { joinGroupRequest, leaveGroupRequest } from '../../../api/community';
import {
  createNotification,
  NOTIFICATION_TYPE,
  SUCCESS_MESSAGES,
} from '../../../services/Notification';
import { handleGroupJoinError } from '../../../utils/groupJoin';

import './style.css';

export const UsersIcon = ({ color, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M28.6874 17.625C28.5889 17.6988 28.4768 17.7526 28.3575 17.7831C28.2383 17.8137 28.1142 17.8205 27.9923 17.803C27.8704 17.7856 27.7532 17.7444 27.6472 17.6817C27.5413 17.6189 27.4487 17.536 27.3749 17.4375C26.8098 16.6779 26.0743 16.0617 25.2276 15.6383C24.3808 15.2149 23.4465 14.9963 22.4999 15C22.3155 14.9999 22.1353 14.9456 21.9816 14.8437C21.828 14.7417 21.7079 14.5968 21.6362 14.4269C21.5875 14.3116 21.5625 14.1877 21.5625 14.0625C21.5625 13.9373 21.5875 13.8134 21.6362 13.698C21.7079 13.5282 21.828 13.3832 21.9816 13.2813C22.1353 13.1794 22.3155 13.125 22.4999 13.125C23.0259 13.1249 23.5414 12.9774 23.9877 12.699C24.4341 12.4207 24.7934 12.0228 25.025 11.5505C25.2565 11.0782 25.351 10.5504 25.2976 10.0271C25.2442 9.50376 25.0452 9.00591 24.723 8.59007C24.4009 8.17423 23.9686 7.85706 23.4752 7.67459C22.9819 7.49213 22.4472 7.45168 21.932 7.55784C21.4168 7.664 20.9417 7.91251 20.5607 8.27515C20.1796 8.63779 19.9079 9.10002 19.7764 9.60934C19.7457 9.72861 19.6917 9.84064 19.6176 9.93905C19.5435 10.0375 19.4508 10.1203 19.3447 10.1829C19.2386 10.2455 19.1212 10.2865 18.9992 10.3037C18.8773 10.3209 18.7531 10.3139 18.6339 10.2832C18.5146 10.2524 18.4025 10.1984 18.3041 10.1243C18.2057 10.0503 18.1229 9.95753 18.0603 9.85143C17.9977 9.74534 17.9567 9.62795 17.9395 9.50598C17.9223 9.38402 17.9292 9.25986 17.96 9.14059C18.1425 8.43432 18.4874 7.78039 18.9671 7.23085C19.4468 6.6813 20.0482 6.2513 20.7234 5.97506C21.3985 5.69883 22.1288 5.58398 22.8562 5.63965C23.5835 5.69532 24.2878 5.91999 24.9131 6.29576C25.5383 6.67153 26.0672 7.18805 26.4577 7.80421C26.8482 8.42036 27.0895 9.11915 27.1624 9.84498C27.2354 10.5708 27.1379 11.3036 26.8777 11.9851C26.6176 12.6667 26.2019 13.278 25.6639 13.7707C26.9387 14.3226 28.0469 15.1985 28.8784 16.3113C28.9522 16.41 29.0059 16.5224 29.0363 16.6419C29.0667 16.7614 29.0732 16.8857 29.0554 17.0078C29.0377 17.1298 28.996 17.2471 28.9329 17.353C28.8697 17.4589 28.7863 17.5513 28.6874 17.625ZM22.3733 24.8437C22.4411 24.9504 22.4867 25.0697 22.5072 25.1945C22.5277 25.3193 22.5228 25.4469 22.4927 25.5697C22.4626 25.6925 22.408 25.808 22.3322 25.9091C22.2563 26.0103 22.1608 26.095 22.0513 26.1583C21.9418 26.2216 21.8207 26.2621 21.6952 26.2773C21.5697 26.2926 21.4424 26.2823 21.3209 26.247C21.1995 26.2118 21.0864 26.1524 20.9886 26.0723C20.8907 25.9923 20.81 25.8933 20.7514 25.7812C20.1609 24.7812 19.3198 23.9525 18.3111 23.3768C17.3025 22.801 16.1612 22.4983 14.9999 22.4983C13.8385 22.4983 12.6972 22.801 11.6886 23.3768C10.68 23.9525 9.83888 24.7812 9.2483 25.7812C9.1897 25.8933 9.10903 25.9923 9.01116 26.0723C8.91329 26.1524 8.80024 26.2118 8.67881 26.247C8.55738 26.2823 8.43007 26.2926 8.30455 26.2773C8.17904 26.2621 8.0579 26.2216 7.94843 26.1583C7.83897 26.095 7.74343 26.0103 7.66757 25.9091C7.59171 25.808 7.5371 25.6925 7.50702 25.5697C7.47694 25.4469 7.47201 25.3193 7.49253 25.1945C7.51305 25.0697 7.5586 24.9504 7.62643 24.8437C8.53533 23.282 9.92119 22.0531 11.5803 21.3375C10.6467 20.6227 9.9606 19.6333 9.61838 18.5084C9.27616 17.3834 9.29506 16.1796 9.67242 15.0659C10.0498 13.9523 10.7666 12.985 11.7222 12.2998C12.6778 11.6147 13.824 11.2462 14.9999 11.2462C16.1757 11.2462 17.3219 11.6147 18.2775 12.2998C19.2331 12.985 19.9499 13.9523 20.3273 15.0659C20.7047 16.1796 20.7236 17.3834 20.3814 18.5084C20.0391 19.6333 19.353 20.6227 18.4194 21.3375C20.0785 22.0531 21.4644 23.282 22.3733 24.8437ZM14.9999 20.625C15.7415 20.625 16.4666 20.405 17.0833 19.993C17.6999 19.5809 18.1806 18.9953 18.4644 18.31C18.7482 17.6248 18.8225 16.8708 18.6778 16.1434C18.5331 15.4159 18.176 14.7478 17.6515 14.2233C17.1271 13.6989 16.4589 13.3417 15.7315 13.197C15.004 13.0523 14.25 13.1266 13.5648 13.4104C12.8796 13.6942 12.2939 14.1749 11.8819 14.7916C11.4698 15.4083 11.2499 16.1333 11.2499 16.875C11.2499 17.8695 11.645 18.8234 12.3482 19.5266C13.0515 20.2299 14.0053 20.625 14.9999 20.625ZM8.43737 14.0625C8.43737 13.8138 8.33859 13.5754 8.16278 13.3996C7.98696 13.2237 7.74851 13.125 7.49987 13.125C6.97385 13.1249 6.45838 12.9774 6.01202 12.699C5.56566 12.4207 5.20629 12.0228 4.97475 11.5505C4.7432 11.0782 4.64875 10.5504 4.70213 10.0271C4.75551 9.50376 4.95457 9.00591 5.27671 8.59007C5.59885 8.17423 6.03115 7.85706 6.52451 7.67459C7.01788 7.49213 7.55252 7.45168 8.06772 7.55784C8.58292 7.664 9.05802 7.91251 9.43906 8.27515C9.8201 8.63779 10.0918 9.10002 10.2233 9.60934C10.2855 9.85021 10.4408 10.0565 10.655 10.1829C10.8693 10.3093 11.125 10.3453 11.3659 10.2832C11.6068 10.221 11.8131 10.0657 11.9394 9.85143C12.0658 9.63716 12.1019 9.38146 12.0397 9.14059C11.8572 8.43432 11.5123 7.78039 11.0326 7.23085C10.5529 6.6813 9.95153 6.2513 9.27637 5.97506C8.60122 5.69883 7.87092 5.58398 7.14357 5.63965C6.41622 5.69532 5.7119 5.91999 5.08666 6.29576C4.46141 6.67153 3.9325 7.18805 3.542 7.80421C3.1515 8.42036 2.9102 9.11915 2.83729 9.84498C2.76438 10.5708 2.86188 11.3036 3.12203 11.9851C3.38217 12.6667 3.79779 13.278 4.3358 13.7707C3.06231 14.3231 1.95539 15.199 1.12487 16.3113C0.975528 16.5102 0.911322 16.7603 0.946375 17.0065C0.981428 17.2528 1.11287 17.475 1.31178 17.6244C1.51069 17.7737 1.76078 17.8379 2.00704 17.8029C2.25329 17.7678 2.47553 17.6364 2.62487 17.4375C3.18993 16.6779 3.92543 16.0617 4.77216 15.6383C5.61889 15.2149 6.5532 14.9963 7.49987 15C7.74851 15 7.98696 14.9012 8.16278 14.7254C8.33859 14.5496 8.43737 14.3111 8.43737 14.0625Z"
      fill={color}
    />
  </svg>
);

UsersIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

UsersIcon.defaultProps = {
  color: '#70A6FF',
  size: 32,
};

export const LeaveGroupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M8.75 16.875C8.75 17.0408 8.68415 17.1997 8.56694 17.3169C8.44973 17.4342 8.29076 17.5 8.125 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H8.125C8.29076 2.5 8.44973 2.56585 8.56694 2.68306C8.68415 2.80027 8.75 2.95924 8.75 3.125C8.75 3.29076 8.68415 3.44973 8.56694 3.56694C8.44973 3.68415 8.29076 3.75 8.125 3.75H3.75V16.25H8.125C8.29076 16.25 8.44973 16.3158 8.56694 16.4331C8.68415 16.5503 8.75 16.7092 8.75 16.875ZM17.3172 9.55781L14.1922 6.43281C14.0749 6.31554 13.9159 6.24965 13.75 6.24965C13.5841 6.24965 13.4251 6.31554 13.3078 6.43281C13.1905 6.55009 13.1247 6.70915 13.1247 6.875C13.1247 7.04085 13.1905 7.19991 13.3078 7.31719L15.3664 9.375H8.125C7.95924 9.375 7.80027 9.44085 7.68306 9.55806C7.56585 9.67527 7.5 9.83424 7.5 10C7.5 10.1658 7.56585 10.3247 7.68306 10.4419C7.80027 10.5592 7.95924 10.625 8.125 10.625H15.3664L13.3078 12.6828C13.1905 12.8001 13.1247 12.9591 13.1247 13.125C13.1247 13.2909 13.1905 13.4499 13.3078 13.5672C13.4251 13.6845 13.5841 13.7503 13.75 13.7503C13.9159 13.7503 14.0749 13.6845 14.1922 13.5672L17.3172 10.4422C17.3753 10.3841 17.4214 10.3152 17.4529 10.2393C17.4843 10.1635 17.5005 10.0821 17.5005 10C17.5005 9.91787 17.4843 9.83654 17.4529 9.76066C17.4214 9.68479 17.3753 9.61586 17.3172 9.55781Z"
      fill="#70A6FF"
    />
  </svg>
);

export const CommunityGroupRow = ({
  group,
  type,
  onClick,
  onLeave,
  onJoin,
  onJoinImmediate,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isJoined, setIsJoined] = useState(type === 'joined');
  const [joiningLoading, setJoiningLoading] = useState(false);
  const [joinToast, setJoinToast] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) return;
    const close = () => setIsMenuOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [isMenuOpen]);

  const handleJoin = async e => {
    e.stopPropagation();
    if (joiningLoading || !group.id) return;
    setJoiningLoading(true);
    try {
      await joinGroupRequest(group.id);
      if (onJoinImmediate) {
        createNotification({
          type: NOTIFICATION_TYPE.SUCCESS,
          message: SUCCESS_MESSAGES.GROUP_JOINED,
        });
        // Skeleton mode: parent replaces this row with a skeleton immediately
        onJoinImmediate(group.id);
      } else if (onJoin) {
        // SuggestedGroups: show existing dark toast, then animate row out and remove
        setJoinToast(true);
        setTimeout(() => {
          setIsLeaving(true);
          setTimeout(() => onJoin(group.id), 300);
        }, 1800);
      } else {
        // No removal callback (other contexts): show joined state with 3-dot menu
        setIsJoined(true);
        setJoinToast(true);
        setTimeout(() => setJoinToast(false), 2500);
      }
    } catch (err) {
      await handleGroupJoinError(err, group.enrollmentType, {
        history,
        dispatch,
      });
    } finally {
      setJoiningLoading(false);
    }
  };

  const handleLeave = async e => {
    e.stopPropagation();
    setIsMenuOpen(false);
    try {
      await leaveGroupRequest(group.id);
      setIsJoined(false);
      createNotification({
        type: NOTIFICATION_TYPE.SUCCESS,
        message: SUCCESS_MESSAGES.GROUP_LEFT,
      });
      if (onLeave) onLeave(group.id);
    } catch {
      createNotification({
        type: NOTIFICATION_TYPE.ERROR,
        message: 'Failed to leave the group. Please try again.',
      });
    }
  };

  const avatar = group.image ? (
    <img
      className="community-group-avatar"
      src={group.image}
      alt={group.title}
    />
  ) : (
    <span className="community-group-avatar community-group-avatar-icon">
      <UsersIcon color="#70A6FF" size={28} />
    </span>
  );

  return (
    <div
      className={isLeaving ? 'community-group-row--leaving-wrap' : undefined}
    >
      <ContentSurface
        className={`community-group-row${
          onClick ? ' community-group-row--clickable' : ''
        }`}
      >
        <div
          className="community-group-info"
          style={onClick ? { flex: 1, cursor: 'pointer' } : undefined}
          onClick={onClick}
          role={onClick ? 'button' : undefined}
          tabIndex={onClick ? 0 : undefined}
          onKeyDown={
            onClick
              ? e => {
                  if (e.key === 'Enter') onClick();
                }
              : undefined
          }
        >
          {avatar}
          <div>
            <h3>{group.title}</h3>
            <p>{group.meta}</p>
          </div>
        </div>
        {!isJoined ? (
          <button
            className={`community-join-btn${
              joiningLoading ? ' community-join-btn--loading' : ''
            }`}
            type="button"
            disabled={joiningLoading}
            onClick={handleJoin}
          >
            {joiningLoading && (
              <span className="community-join-spinner" aria-hidden="true" />
            )}
            {joiningLoading ? 'Joining…' : 'Join'}
          </button>
        ) : (
          <div className="community-row-actions">
            <button
              className="community-more-btn"
              type="button"
              aria-label={`${group.title} options`}
              onClick={e => {
                e.stopPropagation();
                setIsMenuOpen(prev => !prev);
              }}
            >
              <span />
              <span />
              <span />
            </button>
            {isMenuOpen && (
              <button
                className="community-leave-btn"
                type="button"
                onClick={handleLeave}
              >
                <LeaveGroupIcon />
                Leave Group
              </button>
            )}
          </div>
        )}
      </ContentSurface>

      {joinToast && (
        <div className="community-join-toast">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM11.03 6.53L7.53 10.03C7.46 10.1 7.36 10.14 7.25 10.14C7.14 10.14 7.04 10.1 6.97 10.03L4.97 8.03C4.82 7.88 4.82 7.64 4.97 7.49C5.12 7.34 5.36 7.34 5.51 7.49L7.25 9.22L10.49 5.97C10.64 5.82 10.88 5.82 11.03 5.97C11.18 6.12 11.18 6.36 11.03 6.53Z"
              fill="white"
            />
          </svg>
          <span>
            You have joined <strong>{group.title}</strong>
          </span>
        </div>
      )}
    </div>
  );
};

CommunityGroupRow.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    meta: PropTypes.string,
    image: PropTypes.string,
    enrollmentType: PropTypes.shape({
      type: PropTypes.string,
      required_products: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.number }),
      ),
    }),
  }).isRequired,
  type: PropTypes.oneOf(['joined', 'suggested']),
  onClick: PropTypes.func,
  onLeave: PropTypes.func,
  onJoin: PropTypes.func,
  onJoinImmediate: PropTypes.func,
};

CommunityGroupRow.defaultProps = {
  type: 'suggested',
  onClick: null,
  onLeave: null,
  onJoin: null,
  onJoinImmediate: null,
};

const EmptyState = ({ type }) => (
  <ContentSurface className="community-empty-state">
    <span className="community-empty-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M8.01501 18.4752C8.0184 18.5429 8.00798 18.6106 7.98438 18.6742C7.96077 18.7378 7.92448 18.7959 7.87771 18.845C7.83094 18.8941 7.77466 18.9332 7.71231 18.9599C7.64996 18.9866 7.58283 19.0003 7.51501 19.0002H2.00001C1.77431 19.0005 1.55512 18.9245 1.37811 18.7845C1.20109 18.6445 1.07664 18.4487 1.02501 18.2289C0.992865 18.0786 0.994347 17.9229 1.02935 17.7732C1.06436 17.6234 1.13203 17.4832 1.22751 17.3627C2.10977 16.1927 3.28038 15.2714 4.62501 14.6889C4.03467 14.1507 3.5819 13.4788 3.30461 12.7296C3.02732 11.9804 2.9336 11.1756 3.03128 10.3828C3.12897 9.58987 3.41522 8.83193 3.86606 8.17242C4.31691 7.51291 4.91922 6.97103 5.62255 6.59217C6.32588 6.2133 7.10976 6.00849 7.90852 5.99487C8.70729 5.98125 9.49769 6.15923 10.2135 6.51389C10.9294 6.86856 11.5498 7.38959 12.0229 8.03335C12.4959 8.6771 12.8079 9.42484 12.9325 10.2139C12.9486 10.3201 12.9296 10.4285 12.8784 10.5228C12.8272 10.6172 12.7465 10.6922 12.6488 10.7364C11.2618 11.3777 10.0871 12.4022 9.2634 13.6893C8.4397 14.9763 8.00133 16.4721 8.00001 18.0002C8.00001 18.1602 8.00001 18.3177 8.01501 18.4752ZM30.765 17.3614C29.8848 16.1928 28.7169 15.272 27.375 14.6889C27.9654 14.1507 28.4181 13.4788 28.6954 12.7296C28.9727 11.9804 29.0664 11.1756 28.9687 10.3828C28.8711 9.58987 28.5848 8.83193 28.134 8.17242C27.6831 7.51291 27.0808 6.97103 26.3775 6.59217C25.6741 6.2133 24.8903 6.00849 24.0915 5.99487C23.2927 5.98125 22.5023 6.15923 21.7865 6.51389C21.0707 6.86856 20.4502 7.38959 19.9772 8.03335C19.5041 8.6771 19.1922 9.42484 19.0675 10.2139C19.0514 10.3201 19.0704 10.4285 19.1216 10.5228C19.1729 10.6172 19.2535 10.6922 19.3513 10.7364C20.7383 11.3777 21.9129 12.4022 22.7366 13.6893C23.5603 14.9763 23.9987 16.4721 24 18.0002C24 18.1602 24 18.3177 23.985 18.4752C23.9816 18.5429 23.992 18.6106 24.0157 18.6742C24.0393 18.7378 24.0755 18.7959 24.1223 18.845C24.1691 18.8941 24.2254 18.9332 24.2877 18.9599C24.3501 18.9866 24.4172 19.0003 24.485 19.0002H30C30.2257 19.0005 30.4449 18.9245 30.6219 18.7845C30.7989 18.6445 30.9234 18.4487 30.975 18.2289C31.0074 18.0783 31.0059 17.9223 30.9706 17.7723C30.9354 17.6223 30.8673 17.482 30.7713 17.3614H30.765ZM19.64 22.7589C20.6357 21.9964 21.3674 20.941 21.7323 19.7411C22.0972 18.5413 22.0769 17.2572 21.6744 16.0694C21.2718 14.8817 20.5071 13.8499 19.4879 13.1191C18.4686 12.3884 17.246 11.9954 15.9919 11.9954C14.7377 11.9954 13.5151 12.3884 12.4959 13.1191C11.4766 13.8499 10.712 14.8817 10.3094 16.0694C9.90683 17.2572 9.88657 18.5413 10.2515 19.7411C10.6164 20.941 11.3481 21.9964 12.3438 22.7589C10.5769 23.5245 9.1016 24.8356 8.13376 26.5002C8.04599 26.6522 7.99978 26.8247 7.99979 27.0002C7.9998 27.1758 8.04603 27.3483 8.13382 27.5003C8.22161 27.6523 8.34788 27.7785 8.49993 27.8663C8.65199 27.9541 8.82446 28.0002 9.00001 28.0002H23C23.1756 28.0002 23.348 27.9541 23.5001 27.8663C23.6521 27.7785 23.7784 27.6523 23.8662 27.5003C23.954 27.3483 24.0002 27.1758 24.0002 27.0002C24.0002 26.8247 23.954 26.6522 23.8663 26.5002C22.8964 24.8345 21.4183 23.5233 19.6488 22.7589H19.64Z"
          fill="#A6A6AE"
        />
      </svg>
    </span>
    <p className="community-empty-title">No Group</p>
    <p className="community-empty-desc">
      {type === 'joined'
        ? 'You have not joined any groups at this time'
        : 'No suggested groups available right now'}
    </p>
  </ContentSurface>
);

EmptyState.propTypes = {
  type: PropTypes.oneOf(['joined', 'suggested']),
};

EmptyState.defaultProps = { type: 'suggested' };

const CommunityGroupSection = ({
  title,
  groups,
  type,
  onLoadMore,
  hasMore,
  isLoading,
  showPendingRow,
  pendingGroupId,
  onViewAll,
  onGroupClick,
  onGroupLeave,
  onGroupJoin,
  onGroupJoinImmediate,
}) => {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (type !== 'suggested' || !onLoadMore) return;
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !isLoading) {
          onLoadMore();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [type, onLoadMore, hasMore, isLoading]);

  const showSkeleton = isLoading && groups.length === 0;

  return (
    <section className="community-section-block">
      {(showSkeleton || groups.length > 0) && (
        <div className="community-section-header">
          <h2>{title}</h2>
          {!showSkeleton && onViewAll && groups.length > 0 && (
            <button type="button" onClick={onViewAll}>
              View all <span aria-hidden="true" />
            </button>
          )}
        </div>
      )}

      <div className="community-group-list">
        {showSkeleton ? (
          <>
            <GroupRowSkeleton />
            <GroupRowSkeleton />
            <GroupRowSkeleton />
          </>
        ) : groups.length === 0 ? (
          <EmptyState type={type} />
        ) : (
          <>
            {groups.map(group =>
              group.id === pendingGroupId ? (
                <GroupRowSkeleton key={group.id} />
              ) : (
                <CommunityGroupRow
                  key={group.id || group.title}
                  group={group}
                  type={type}
                  onClick={onGroupClick ? () => onGroupClick(group) : null}
                  onLeave={onGroupLeave || null}
                  onJoin={onGroupJoin || null}
                  onJoinImmediate={onGroupJoinImmediate || null}
                />
              ),
            )}
            {showPendingRow && <GroupRowSkeleton />}
          </>
        )}
      </div>

      {type === 'suggested' && (
        <div ref={sentinelRef} className="community-scroll-sentinel" />
      )}
      {isLoading && groups.length > 0 && !showPendingRow && !pendingGroupId && (
        <GroupRowSkeleton />
      )}
    </section>
  );
};

CommunityGroupSection.propTypes = {
  title: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string.isRequired,
      meta: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
  type: PropTypes.oneOf(['joined', 'suggested']),
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  showPendingRow: PropTypes.bool,
  pendingGroupId: PropTypes.string,
  onViewAll: PropTypes.func,
  onGroupClick: PropTypes.func,
  onGroupLeave: PropTypes.func,
  onGroupJoin: PropTypes.func,
  onGroupJoinImmediate: PropTypes.func,
};

CommunityGroupSection.defaultProps = {
  type: 'suggested',
  onLoadMore: null,
  hasMore: false,
  isLoading: false,
  showPendingRow: false,
  pendingGroupId: null,
  onViewAll: null,
  onGroupClick: null,
  onGroupLeave: null,
  onGroupJoin: null,
  onGroupJoinImmediate: null,
};

export default CommunityGroupSection;
